

export const VERSION_METHODO = 2